import { JSX, useContext, useEffect } from "react";
import { ColumnConfig } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { InvalidItemsTableData, ResultsSummaryTableData } from "@app/shared/provider-change-wizards/interfaces";
import PageSection from "@app/shared/PageSection";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { UploadExceptionsContext } from "@app/exceptions/contexts/UploadExceptionsContext";
import { WizardStepProps } from "@app/exceptions/contexts/interfaces";

const UploadExceptionsReview = (props: WizardStepProps): JSX.Element => {
  const uploadExceptionsContext = useContext(UploadExceptionsContext);

  const reviewColumnConfig: ColumnConfig = {
    invalidItems: {
      displayText: "Invalid Items",
      noFilter: true,
      noSort: true,
      testId: "invalid-items",
    },
    validItems: {
      displayText: "Results Summary",
      noFilter: true,
      noSort: true,
      testId: "results-summary",
    }
  };

  useEffect(() => {
    props.pageIsValid(!uploadExceptionsContext.loading);
  }, [uploadExceptionsContext.loading]);

  return (
    
    <PageSection>

      {uploadExceptionsContext.totalOverwrittenExceptions > 0 && 
        <div className="container mt-3">
          <QESAlert type="warning" persist={true} classNames="mt-3">Uploading this file will update/overwrite {uploadExceptionsContext.totalOverwrittenExceptions} existing and corresponding Specialty Exception{uploadExceptionsContext.totalOverwrittenExceptions == 1 ? '': 's'}</QESAlert>
        </div>
      }

      <div className="container">
        <div className="mb-2">
          <Waffles<InvalidItemsTableData>
            columns={reviewColumnConfig}
            data={uploadExceptionsContext.invalidItems}
            fullWidth={true}
            hideTableHead={uploadExceptionsContext.invalidItems[0].invalidItems.props.children.every((element: JSX.Element) => !element)}
            testId="upload-exceptions__invalid-items"
          />
        </div>
        <div className="mb-2">
          <Waffles<ResultsSummaryTableData>
            columns={reviewColumnConfig}
            data={uploadExceptionsContext.resultsSummary}
            fullWidth={true}
            testId="upload-exceptions__results-summary"
          />
        </div>
      </div>
    </PageSection>
  );
};

export default UploadExceptionsReview;
